<mat-sidenav-container class="listSideNav">
  <mat-card *ngIf="preference" style="margin-left: -2px;">

    <div class="header">
      <div *ngIf="!project.isEditable">
        <h4>
          <span style="color: rgba(0, 0, 0, 0.87)"
            (click)="project.default ? project.isEditable = false : project.isEditable = true">{{project?.name}}</span>
          <mat-icon [matMenuTriggerFor]="menu">more_horiz</mat-icon>
          <!-- <h6 class="shareWith">
            <span *ngFor="let users of sharedNames">
              {{users.name}},&nbsp;
            </span>
          </h6> -->
          <!-- <div class="editList"> -->
          <mat-menu #menu="matMenu" class="optionList">
            <h6>Options</h6>
            <hr>
            <button mat-menu-item (click)="project.isEditable = true" [hidden]="project.default">
              <mat-icon class="iconFix">border_color</mat-icon>
              <span class="fontFix">Rename list</span>
            </button>
            <button mat-menu-item (click)="shareDialog()" [hidden]="project.default">
              <mat-icon class="iconFix">group_add</mat-icon>
              <span class="fontFix">Share list</span>
            </button>
            <!-- <button mat-menu-item (click)="shareDialog()" [hidden]="project.default">
              <mat-icon class="iconFix">group</mat-icon>
              <span class="fontFix">UnShare list</span>
            </button> -->
            <button mat-menu-item *ngIf="!preference?.hide_completed_subtask_on"
              (click)="project.hideCompleteTask = !project.hideCompleteTask">
              <mat-icon class="iconFix" [style.color]="project.hideCompleteTask ? '#039be5' : 'grey'">
                {{project.hideCompleteTask ? 'check_circle' : 'check_circle_outline'}}</mat-icon>
              <span class="fontFix">{{project.hideCompleteTask ? 'Show' : 'Hide'}} completed tasks</span>
            </button>
            <hr [hidden]="project.default">
            <button mat-menu-item (click)="hideConfirmationProject(project)" [hidden]="project.default">
              <mat-icon class="iconFix" style="color:#db3a29">delete</mat-icon>
              <span class="fontFix" style="color:#db3a29">Delete list</span>
            </button>
          </mat-menu>

          <!-- </div> -->
        </h4>

        <div style="text-align: right;">
          <button mat-icon-button *ngIf="project.shared_with" (click)="shareDialog()">
            <mat-icon>supervised_user_circle</mat-icon>
          </button>
          <button mat-button color="accent" [matMenuTriggerFor]="sort">
            <mat-icon color="accent">swap_vert</mat-icon>
            Sort
          </button>
          <mat-menu #sort="matMenu" class="optionList" matSort (change)="sortData($event)">
            <h6>Sort By</h6>
            <hr>
            <button mat-menu-item (click)="sortData('starred')">
              <mat-icon class="iconFix">star_border</mat-icon>
              <span class="fontFix" mat-sort>Important</span>
            </button>
            <button mat-menu-item (click)="sortData('due_date')">
              <mat-icon class="iconFix">event_note</mat-icon>
              <span class="fontFix" mat-sort>Due date</span>
            </button>
            <button mat-menu-item (click)="sortData('my_day')">
              <mat-icon class="iconFix">wb_sunny</mat-icon>
              <span class="fontFix" mat-sort>Added to My Day</span>
            </button>
            <button mat-menu-item [matMenuTriggerFor]="priority">
              <mat-icon class="iconFix">flag</mat-icon>
              <span class="fontFix" mat-sort>Priority</span>
            </button>
            <mat-menu #priority="matMenu" class="optionList">
              <button mat-menu-item (click)="sortData('HIGH')">
                <mat-icon class="iconFix" style="color: red">flag</mat-icon>
                <span class="fontFix" mat-sort>HIGH</span>
              </button>
              <button mat-menu-item (click)="sortData('MEDIUM')">
                <mat-icon class="iconFix" style="color: #f1e789">flag</mat-icon>
                <span class="fontFix" mat-sort>MEDIUM</span>
              </button>
              <button mat-menu-item (click)="sortData('LOW')">
                <mat-icon class="iconFix" style="color: gray">flag</mat-icon>
                <span class="fontFix" mat-sort>LOW</span>
              </button>
            </mat-menu>
            <button mat-menu-item (click)="sortData('is_completed')">
              <mat-icon class="iconFix">check_circle_outline</mat-icon>
              <span class="fontFix" mat-sort>Completed</span>
            </button>
            <button mat-menu-item (click)="sortData('title')">
              <mat-icon class="iconFix">swap_vert</mat-icon>
              <span class="fontFix" mat-sort>Alphabetically</span>
            </button>
            <!-- <button mat-menu-item (click)="sortData('creation')">
              <mat-icon class="iconFix">insert_invitation</mat-icon>
              <span class="fontFix" mat-sort>Creation date</span>
            </button> -->
          </mat-menu>
        </div>
      </div>
      <div class="update" *ngIf="project.isEditable">
        <input matInput [eguardAutofocus] on-focusout="project.isEditable = false" type="text"
          [(ngModel)]="project.name" (change)="updateProject(project);project.isEditable = false">
      </div>


    </div>


    <div class="content">
      <mat-list role="list">
        <mat-list-item role="listitem" [hidden]="project.hideCompleteTask && task.is_completed"
          *ngFor="let task of sortedData">
          <button mat-icon-button (click)="task.is_completed = !task.is_completed; updateTask(task)">
            <mat-icon [style.color]="task.is_completed ? '#039be5' : 'grey'" style="margin-top: -10px;">
              {{task.is_completed ? 'check_circle' : 'check_circle_outline'}}</mat-icon>
          </button>
          <div class="title" (click)="selectedTask = task; left.open()">
            <label *ngIf="task.is_completed === false">
              {{task.title}}
            </label>
            <label *ngIf="task.is_completed === true">
              <del> {{task.title}}</del>
            </label>
            <br>

            <button *ngIf="task.steps.length">
              <span>{{stepsComplete(task)}} to {{task.steps.length}}</span>
            </button>
            <button class="{{task.my_day}}" *ngIf="task.my_day">
              <mat-icon style="color: rgb(3, 155, 229);">wb_sunny</mat-icon>
              <span class="my_dayStatus-{{task.my_day}}" style="color: rgb(3, 155, 229);">My Day</span>
            </button>
            <button class="{{task.due_date}}">
              <mat-icon *ngIf="task.due_date">event_available</mat-icon>
              <span [style.color]="setColor(task)">{{task.due_date |date}}</span>
            </button>
            <button class="note">
              <mat-icon *ngIf="task.note">note</mat-icon>
              <span *ngIf="task.note" class="noteStatus-{{task.note}}">Note</span>
            </button>
            <button class="remind">
              <mat-icon *ngIf="task.remind">notification_important</mat-icon>
              <span *ngIf="task.remind" class="remindStatus-{{task.remind}}">Remind</span>
            </button>

            <mat-menu #rightMenu="matMenu" class="optionList">
              <button mat-menu-item (click)="addMyDay(task)">
                <mat-icon class="iconFix">wb_sunny</mat-icon>
                <span class="fontFix">Add to My Day</span>
              </button>
              <button mat-menu-item (click)="task.is_completed = !task.is_completed; updateTask(task)">
                <mat-icon class="iconFix" [style.color]="task.is_completed ? '#039be5' : 'grey'">
                  {{task.is_completed ? 'check_circle' : 'check_circle_outline'}}</mat-icon>
                <span class="fontFix">Mark as completed</span>
              </button>
              <button mat-menu-item (click)="task.starred = !task.starred; updateTask(task)">
                <mat-icon [style.color]="task.starred ? '#f1e789' : 'grey'">{{task.starred ? 'star' : 'star_border'}}
                </mat-icon>
                <span class="fontFix">Mark as important</span>
              </button>
              <hr>
              <button mat-menu-item (click)="addDueDate('today',task)">
                <mat-icon class="iconFix">date_range</mat-icon>
                <span class="fontFix">Due today</span>
              </button>
              <button mat-menu-item (click)="addDueDate('tomorrow',task)">
                <mat-icon class="iconFix">date_range</mat-icon>
                <span class="fontFix">Due tomorrow</span>
              </button>
              <hr>
              <button mat-menu-item (click)="createNewList(task)">
                <mat-icon class="iconFix">add</mat-icon>
                <span class="fontFix">Create a new list from this task</span>
              </button>
              <button mat-menu-item [matMenuTriggerFor]="move">
                <mat-icon class="iconFix">move_to_inbox</mat-icon>
                <span class="fontFix">Move Task To</span>
              </button>

              <mat-menu #move="matMenu" class="optionList">
                <button mat-menu-item *ngFor="let project of projects" (click)="getTaskMove(task, project)">
                  <mat-icon class="iconFix">list_alt</mat-icon>
                  <span class="fontFix" style="text-transform: capitalize;">{{project.name}}</span>
                </button>
              </mat-menu>

              <button mat-menu-item [matMenuTriggerFor]="copy">
                <mat-icon class="iconFix">file_copy</mat-icon>
                <span class="fontFix">Copy Task To</span>
              </button>

              <mat-menu #copy="matMenu" class="optionList">
                <button mat-menu-item *ngFor="let project of projects" (click)="getTaskCopy(task, project)">
                  <mat-icon class="iconFix">list_alt</mat-icon>
                  <span class="fontFix" style="text-transform: capitalize;">{{project.name}}</span>
                </button>
              </mat-menu>

              <hr>
              <!-- <button mat-menu-item (click)='deleteTask(task)'> -->
              <button mat-menu-item (click)='hideConfirmationTask(task)'>
                <mat-icon class="iconFix" style="color:#db3a29">delete</mat-icon>
                <span class="fontFix" style="color:#db3a29">Delete selected task</span>
              </button>
            </mat-menu>
          </div>
          <mat-icon *ngIf="task.assigned_to" style="color: #039be5;">how_to_reg</mat-icon>
          <button mat-icon-button (click)="task.starred = !task.starred; updateTask(task)">
            <mat-icon [style.color]="task.starred ? '#f1e789' : 'grey'">{{task.starred ? 'star' : 'star_border'}}
            </mat-icon>
          </button>
          <button class="{{task.priority}}" (click)="changePriority(task)">
            <mat-icon class="iconFix">flag</mat-icon>
          </button>
          <button mat-icon-button [matMenuTriggerFor]="rightMenu">
            <mat-icon>more_vert</mat-icon>
          </button>
        </mat-list-item>
      </mat-list>
      <!-- <div class="inputBox"> -->
      <button mat-icon-button class="addInput">
        <mat-icon>add</mat-icon>
      </button>
      <input matInput type="text" style="width: 90%;padding: 10px 0;" [(ngModel)]="task" placeholder="Add a task"
        (change)="addNewTask(task)">
      <hr>
      <!-- </div> -->
    </div>

  </mat-card>

  <mat-sidenav mode="side" #left position="end">
    <mat-card class="side-card">
      <div class="todo-sidenav">
        <todo-side-nav [task]="selectedTask" [project]="project" (upDateList)='upDateList($event)'></todo-side-nav>
      </div>

      <div class="todo-footer" *ngIf="project">
        <button mat-icon-button (click)="left.toggle()">
          <mat-icon>input</mat-icon>
        </button>
        Created On {{selectedTask?.created_date | date:'EEE, MMMM dd'}}
        <button mat-icon-button>
          <mat-icon matSuffix (click)='hideConfirmationTask(selectedTask)'>delete</mat-icon>
        </button>
      </div>
    </mat-card>
  </mat-sidenav>
</mat-sidenav-container>



// WEBPACK FOOTER //
// ./src/app/main/content/common/todo-tab/todo-list/todo-list.component.html